
// Dependencies
import Vue from 'vue'
import VueRouter from 'vue-router'
import vueResource from 'vue-resource'
import VeeValidate from 'vee-validate'
import VueProgressBar from 'vue-progressbar'

// Components

import Dashboard from './components/Dashboard/index.vue'
import Login from './components/Login/index.vue'
import Users from './components/Users/index.vue'
import Cnpros from './components/Cnpros/index.vue'
import Contracts from './components/Contracts/index.vue'
import Cnsurveys from './components/Cnsurveys/index.vue'
import Businesses from './components/Businesses/index.vue'
import Forums from './components/Forums/index.vue'
import Payments from './components/Payments/index.vue'
import CNpayments from './components/CNpayments/index.vue'
import CNpaymentsRemita from './components/CNpaymentsRemita/index.vue'
import CNpaymentsPaga from './components/CNpaymentsPaga/index.vue'
import Settings from './components/Settings/index.vue'
import BusinessCategories from './components/BusinessCategories/index.vue'
import CNproCategories from './components/CNproCategories/index.vue'
import CNwallets from './components/CNwallets/index.vue'
import Rewards from './components/Rewards/index.vue'
import Referrals from './components/Referrals/index.vue'
import Messages from './components/Messages/index.vue'
import CNdiscounts from './components/CNdiscounts/index.vue'
import CNinsurance from './components/CNinsurance/index.vue'
import CNinsuranceForms from './components/CNinsuranceForms/index.vue'
// import Dashboard from './components/Dashboard/index.vue'
// import Profile from './components/Profile/index.vue'
// 
// import Cnpro from './components/Cnpro/index.vue'
// import CnproSearch from './components/CnproSearch/index.vue'
// import Businesses from './components/Businesses/index.vue'
// import BusinessSearch from './components/BusinessSearch/index.vue'
// import CnproAccounts from './components/CnproAccounts/index.vue'
// import BusinessListings from './components/BusinessListings/index.vue'
// 
// import SavedListings from './components/SavedListings/index.vue'
// import Forums from './components/Forums/index.vue'
// import Forum from './components/Forum/index.vue'
// 
// import Cnsurvey from './components/Cnsurvey/index.vue'
// import CnsurveyRequests from './components/CnsurveyRequests/index.vue'
// import Pricing from './components/Pricing/index.vue'
// import Terms from './components/Terms/index.vue'
// import Policy from './components/Policy/index.vue'
// import About from './components/About/index.vue'
// import HowItWorks from './components/HowItWorks/index.vue'
// import MyMoney from './components/MyMoney/index.vue'

Vue.config.productionTip = false



Vue.use(VueRouter)
Vue.use(vueResource)
Vue.use(VeeValidate)
Vue.use(VueProgressBar, {
  color: 'rgb(143, 255, 199)',
  failedColor: 'red',
  height: '5px'
})

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [
    {path: '/', name: 'Login', component: Login},
    {path: '/dashboard', name: 'Dashboard', component: Dashboard},
    {path: '/users', name: 'Users', component: Users},
    {path: '/cnpros', name: 'Cnpros', component: Cnpros},
    {path: '/contracts', name: 'Contracts', component: Contracts},
    {path: '/cnsurveys', name: 'Cnsurveys', component: Cnsurveys},
    {path: '/businesses', name: 'Businesses', component: Businesses},
    {path: '/forums', name: 'Forums', component: Forums},
    {path: '/payments', name: 'Payments', component: Payments},
    {path: '/settings', name: 'Settings', component: Settings},
    {path: '/cnpayments', name: 'CNpayments', component: CNpayments},
    {path: '/cnpaymentsremita', name: 'CNpaymentsRemita', component: CNpaymentsRemita},
    {path: '/cnpaymentspaga', name: 'CNpaymentsPaga', component: CNpaymentsPaga},
    {path: '/business_categories', name: 'BusinessCategories', component: BusinessCategories},
    {path: '/cnpro_categories', name: 'CNproCategories', component: CNproCategories},
    {path: '/cnwallets', name: 'CNwallets', component: CNwallets},
    {path: '/rewards', name: 'Rewards', component: Rewards},
    {path: '/referrals', name: 'Referrals', component: Referrals},
    {path: '/messages', name: 'Messages', component: Messages},
    {path: '/cndiscounts', name: 'CNdiscounts', component: CNdiscounts},
    {path: '/cninsurance', name: 'CNinsurance', component: CNinsurance},
    {path: '/cninsuranceforms', name: 'CNinsuranceForms', component: CNinsuranceForms},
    
    // {path: '/dashboard', name: 'Dashboard', component: Dashboard},
    // {path: '/profile', name: 'Profile', component: Profile},
    // 
    // {path: '/cnpro-search', name: 'CnproSearch', component: CnproSearch},
    // {path: '/cnpro', name: 'Cnpro', component: Cnpro},
    // {path: '/businesses', name: 'Businesses', component: Businesses},
    // {path: '/business-search', name: 'BusinessSearch', component: BusinessSearch},
    // {path: '/cnpro-accounts', name: 'CnproAccounts', component: CnproAccounts},
    // {path: '/business-listings', name: 'BusinessListings', component: BusinessListings},
    // 
    // {path: '/saved-listings', name: 'SavedListings', component: SavedListings},
    // {path: '/forums', name: 'Forums', component: Forums},
    // {path: '/forum', name: 'Forum', component: Forum},
    // 
    // {path: '/cnsurvey', name: 'Cnsurvey', component: Cnsurvey},
    // {path: '/survey-requests', name: 'CnsurveyRequests', component: CnsurveyRequests},
    // {path: '/pricing', name: 'Pricing Page', component: Pricing},
    // {path: '/terms', name: 'Terms', component: Terms},
    // {path: '/policy', name: 'Policy', component: Policy},
    // {path: '/about', name: 'About', component: About},
    // {path: '/how-it-works', name: 'HowItWorks', component: HowItWorks},
    // {path: '/mymoney', name: 'MyMoney', component: MyMoney},
    {path: '*', redirect: '/'} // 404
  ]
})

/* eslint-disable no-new */
new Vue({
  router,
  template: `
    <div id="app">
      <vue-progress-bar></vue-progress-bar>
      <router-view></router-view>
    </div>
    `
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js